<template>
  <div class="animated fadeIn">
    <default-heading class="mt-3">Reports</default-heading>
    <div class="my-4"></div>
    <b-alert show>Currently no reports.</b-alert>
  </div>
</template>

<script>

  import DefaultHeading from "../../components/shared/DefaultHeading";

  export default {
    components: {DefaultHeading},
    name: 'ResultIndex',
    data() {
      return {}
    },
    methods: {

    },
    mounted() {

    }
  }
</script>
